
import axios from "axios"
import AbstractAxiosMock from './AbstractAxiosMock'
import { config } from '@/config'
import { dayjs, formatServer, timeZone } from '@/helpers/dayjs'

export default class ShopmanagerServiceMock extends AbstractAxiosMock {

	constructor(...args) {
		super(...args)
		this.fakeCartItems = []
		this.fakeCoupon = null
		this.fakeToken = "fake-not-initialized"
		this.fakeFailOpenOnce = false
		this.fakeBasketState = "cart" //completed
		this.fakePayment = null
		this.fakeTip = null
		this.fakeFormData = null
		this.fakeCo2Compensate = false
		this.fakeAccountCoupon = []
		this.fakeAccountMergeWithMe = {}
		this.fakeChildProducts = {}
		this.fakeProducts = []
		this.fakeDeliverTime = null
		this.fakeOrderNow = null
		this.additionalProductCodes = ["10561004", "10563002", "10563014", "10563015", "10563021"]
		this.timelimitedProductCodes = ["10155016", "10101001"]
		this.timelimitedTime = "12:00"
		this.productsCache = null
		this.fakeCartItemId = 0
	}

	async "GET /shop-api/taxon-products/by-code/:slug"(method, url, { path: { slug } }) {
		const result = await this.__getTaxonProducts()

		//filter slug fake
		result.data.items = result.data.items
			.filter(item => item.taxons.others.find(p => p == slug || p.taxon == slug || slug == 'all' ))

		//filter timelimited items
		const isLimitedTime = this.fakeDeliverTime ? this.fakeDeliverTime.indexOf(this.timelimitedTime) >= 0 : true
		result.data.items = result.data.items
			.filter(item => !(this.timelimitedProductCodes.includes(item.code) && !isLimitedTime))

		//mock images
		result.data.items.forEach(p => {
			for (let image of p.images) {
				if (image.path.indexOf("http") != 0) {
					image.path = config.MOCK_PRODUCT_IMAGE
				}
			}
		})

		// fix original price
		let fixOriginalPrice = (entity) => {
			entity.originalPrice = entity.originalPrice || entity.price
		}
		result.data.items.forEach(p => {
			fixOriginalPrice(p)
			Object.values(p.variants).forEach(fixOriginalPrice)
		})

		// //inflate items
		// let minLength = 20
		// let startLen = result.data.items.length
		// while (startLen > 0 && result.data.items.length < minLength) {
		// 	const itemClone = JSON.parse(JSON.stringify(result.data.items[result.data.items.length % startLen]))
		// 	const newCode = itemClone.code + "-" + result.data.items.length
		// 	itemClone.variants[itemClone.code].code = newCode
		// 	itemClone.code = newCode
		// 	result.data.items.push(itemClone)
		// }

		if (config.MOCK_SHOPLIST_LIMITSTOCK) {
			result.data.items.forEach((product, i) => {
				if (i == 0) {
					this.__fakeProductStock(product, "gradient")
				} else if (i == 2) {
					this.__fakeProductStock(product, "none")
				}
			})
		}

		// decouple from frontend modifications
		result.data = JSON.parse(JSON.stringify(result.data))

		return result
	}

	async "POST /shop-api/carts"() {
		let res = await axios.get(config.MOCK_CART_CREATE_URL, { params: { rand: Math.random() } })
		if (this.fakeFailOpenOnce) {
			this.fakeFailOpenOnce = false
			return this.fakeRequest({
				"code": "42",
				"message": "not all cartitems can be migrated",
				"items": [
					this.__fakeCartItem(1, false),
					this.__fakeCartItem(1, false, ""),
				]
			}, 400)
		}
		this.fakeToken = `fake-${(new Date()).toISOString()}`
		res.data.tokenValue = this.fakeToken
		return res
	}

	async "GET /shop-api/carts/:token"(method, url, { path: { token } } = { path: { token: "" } }) {
		let res = await axios.get(config.MOCK_CART_GET_URL, { params: { rand: Math.random() } })
		const { data: taxonProducts } = await this.__getTaxonProducts()

		// if (config.BRAND == 'pokenation') {
		// 	res.data.channel.code = 'pokenation_zurich'
		// }

		// res.data.items.forEach(p => {
		// 	for (let image of p.product.images) {
		// 		if (image.path.indexOf("http") != 0) {
		// 			image.path = config.MOCK_PRODUCT_IMAGE
		// 		}
		// 	}
		// })

		res.data.products.forEach(p => {
			for (let image of p.images) {
				if (image.path.indexOf("http") != 0) {
					image.path = config.MOCK_PRODUCT_IMAGE
				}
			}
		})

		//console.info("mock: intercept cart", res.data)
		res.data.checkoutState = this.fakeBasketState
		res.data.tokenValue = token || this.fakeToken
		res.data.cartDiscounts = {}
		res.data.couponCode = ""
		if (!config.MOCK_BASKET_HAS_ADDRESS) {

		}
		if (config.MOCK_CART_HASALCOHOL) {
			res.data.alcoholCheck = true
		}
		if (this.fakePayment) {
			res.data.payments.length = 0
			res.data.payments.push(this.fakePayment)
		}
		if (this.fakeCoupon) {
			res.data.cartDiscounts[this.fakeCoupon.name] = this.fakeCoupon
			res.data.couponCode = this.fakeCoupon.name
		}
		if (this.fakeFormData) {
			Object.assign(res.data, this.fakeFormData)
		} else {

		}

		// fake openhours
		if (res.data.channel) {
			this.__fakeLocationTimes(res.data.channel.location)
		}

		res.data.items = []

		res.data.items.push(...this.fakeCartItems)

		if (config.MOCK_CART_HASTIP && this.fakeTip == null) {
			this.fakeTip = this.__fakeCartTip({ value: 400 })
		}
		if (this.fakeTip && res.data.items.length > 0) {
			res.data.items.push(this.fakeTip)
		}

		// product references (new api)
		let products = taxonProducts.items
		this.fakeProducts.forEach(v => (products.find(p => p.code == v.code) == null) && products.push(v))
		res.data.products.forEach(v => (products.find(p => p.code == v.code) == null) && products.push(v))

		let derefProduct = (object, key) => {
			const p = object[key]
			if (typeof p === 'object' && p.code !== null) {
				if (!products.find(v => v.code === p.code)) {
					products.push(p)
				}
				object[key] = p.code
			}
		}
		res.data.items.forEach((v) => derefProduct(v, 'product'))
		res.data.availableChildProducts.forEach((v, i, a) => derefProduct(a, i))
		res.data.availableAdditionalProducts.forEach(
			(rule) => rule.products.forEach(
				(v, i, a) => derefProduct(a, i)
			)
		)
		res.data.products = products

		this.__fixCart(res.data)

		// decouple from frontend modifications
		res.data = JSON.parse(JSON.stringify(res.data))
		return res
	}

	async "PUT /shop-api/carts/:token/delivertime"(method, url, { deliverTime, orderNow, confirmChange }) {
		const basketHasItems = this.fakeCartItems.length > 0
		if (deliverTime.indexOf("12:30") >= 0) {
			return this.fakeRequest({
				"message": "shop_manager.location.not_supported_deliver_time",
				"withoutChanges": false
			}, 400)
		} else if (!confirmChange && basketHasItems) {
			const tempItem = { ...this.fakeCartItems[0] }

			for (let image of tempItem.product.images) {
				if (image.path.indexOf("http") != 0) {
					image.path = config.MOCK_PRODUCT_IMAGE
				}
			}

			return this.fakeRequest({
				"message": "shop_manager.ui.order.some_items_are_missing_for_proposed_delivery_time",
				"notAvailableItems": [
					tempItem
				],
				"withoutChanges": false
			}, 400)
		}
		if (basketHasItems && confirmChange) {
			this.fakeCartItems.shift()
		}
		this.fakeDeliverTime = deliverTime
		this.fakeOrderNow = orderNow
		//request cart and give it
		let cartData = await this["GET /shop-api/carts/:token"]()
		return this.fakeRequest({
			cart: cartData.data,
			notAvailableItems: [],
			withoutChanges: true
		}, 200)
	}

	async "PUT /shop-api/carts/:token/reset-additional-products"(method, url, { resetAdditionalProductsModified }) {
		return this.fakeRequest({
			resetAdditionalProductsModified
		}, 200)
	}

	async "GET /shop-api/taxons/:brand"(method, url, { path: { brand }, params: { channel } }) {
		const result = await axios.get(config.MOCK_CATEGORIES_URL, { params: { rand: Math.random() } })
		let root = result.data.self.children.find(v => v.code == brand)
		if (!root) {
			root = result.data.self
		}
		if (brand == 'missmiu') {
			root = {
				...result.data.self,
				children: result.data.self.children.filter(taxon => taxon.code == 'angrychicken' || taxon.code == 'missmiu' )
			}
		}
		// transform our mock to new spec
		result.data = {
			self: root,
			parentTree: null
		}
		return result
	}

	async "POST /shop-api/carts/:token/multiple-items"(method, url, { items }) {
		const result = await axios.get(config.MOCK_CART_GET_URL, { params: { rand: Math.random() } })
		const { data: taxonProducts } = await this.__getTaxonProducts()
		items.forEach((item) => {
			let product = taxonProducts.items.find(p => p.code == item.productCode) || result.data.products.find(p => p.code == item.productCode)
			if (product) {
				let existingItem = this.fakeCartItems.find(cartItem => cartItem.product.code == item.productCode && cartItem.variantCode == item.variantCode )
				let variant = product.variants.find(v => v.code === item.variantCode)
				if (existingItem && !item.forceCopy) {
					existingItem.quantity += item.quantity
				} else {
					let cartItem = {
						"id": this.fakeCartItemId++,
						"quantity": item.quantity,
						"total": item.quantity * variant.price.current,
						"product": product,
						"variantCode": item.variantCode,
						children: [],
					}
					this.__setItemChildren(cartItem, item.childCodes, result.data.products)
					this.fakeCartItems.push(cartItem)
				}

			} else if (this.additionalProductCodes.includes(item.productCode)) {
				this.fakeCartItems.push(
					this.__fakeCartAdditionalItem({
						quantity: 1,
						free: true,
						code: item.productCode
					}),
					this.__fakeCartAdditionalItem({
						quantity: item.quantity - 1,
						free: false,
						code: item.productCode
					})
				)
			} else if (item.productCode == "783409") {
				const cartItem = this.__fakeCartItem({
					quantity: item.quantity,
					editable: true,
					configurable: true,
					code: item.productCode,
					name: "Bowl",
					price: 1250,
					variantName: item.productCode != item.variantCode ? "Glutenfrei" : "Normal",
				});

				const childBasketItems = result.data.availableChildProducts.reduce((p, c) => {
					if (item.childCodes && item.childCodes.includes(c.code)) {
						p.push(this.__fakeCartItem({
							quantity: 1,
							editable: false,
							name: c.name,
							code: c.code
						}))
					}
					return p
				}, []);

				if (childBasketItems.length) {
					this.fakeChildProducts[cartItem.id] = childBasketItems
				}

				this.fakeCartItems.push(cartItem);
			} else {
				this.fakeCartItems.push(this.__fakeCartItem({
					quantity: item.quantity,
					variantName: item.productCode != item.variantCode ? "Variant" : undefined,
					code: item.productCode
				}))
			}

			let products = this.fakeProducts
			// deref
			let derefProduct = (object, key) => {
				const p = object[key]
				if (typeof p === 'object' && p.code !== null) {
					if (!products.find(v => v.code === p.code)) {
						products.push(p)
					}
					object[key] = p.code
				}
			}
			this.fakeCartItems.forEach((v) => derefProduct(v, 'product'))
		})

		return this["GET /shop-api/carts/:token"]()
	}

	async "PUT /shop-api/carts/:token/items/:identifier"(method, url, { quantity }, { path: { identifier } }) {
		let item = this.fakeCartItems.find(v => v.id == identifier)
		if (item) {
			item.quantity = quantity
		}
		return this["GET /shop-api/carts/:token"]()
	}

	async "DELETE /shop-api/carts/:token/items/:identifier"(method, url, { path: { identifier } }) {
		let idx = this.fakeCartItems.findIndex(v => v.id == identifier)
		if (idx >= 0) {
			delete this.fakeChildProducts[identifier]
			this.fakeCartItems.splice(idx, 1)
		}
		return this["GET /shop-api/carts/:token"]()
	}

	async "PUT /shop-api/carts/:token/items/:identifier/products"(method, url, { childCodes }, { path: { identifier, token } }) {
		const result = await axios.get(config.MOCK_CART_GET_URL, { params: { rand: Math.random() } })
		const item = this.fakeCartItems.find(item => item.id == identifier)
		this.__setItemChildren(item, childCodes, result.data.products)

		return this["GET /shop-api/carts/:token"]()
	}

	"PUT /shop-api/carts/:token/coupon"(method, url, { coupon }) {
		//TODO: implement checkout fail condition
		if (coupon == "fail") {
			return this.fakeRequest({
				"code": 400,
				"message": "Validation failed",
				"errors": {
					"coupon": [
						"Dieser Gutschein ist ungültig."
					]
				}
			}, 400)
		} else {
			this.fakeCoupon = this.__fakeCoupon(coupon)
			return this["GET /shop-api/carts/:token"]()
		}
	}

	"DELETE /shop-api/carts/:token/coupon"() {
		this.fakeCoupon = null
		return this["GET /shop-api/carts/:token"]()
	}

	/*
	 * Checkout
	 */
	async "GET /shop-api/checkout/:token"() {
		//HACK: this currently puts out the basket

		let summary = await axios.get(config.MOCK_CHECKOUT_URL)
		if (config.MOCK_CHECKOUT_PREFILL && summary.data) {
			this.fakeFormData = {
				shippingAddress: summary.data.shippingAddress,
				billingAddress: summary.data.billingAddress,
				email: summary.data.email,
				deliverNow: summary.data.deliverNow,
				deliverTime: summary.data.deliverTime,
				notes: ""
			}
			this.fakeFormData.deliverTime = dayjs().add(2, 'hour').startOf('hour').format()

		}
		return this["GET /shop-api/carts/:token"]()
	}

	"PUT /shop-api/checkout/:token/address"(method, url, { shippingAddress, billingAddress }) {
		this.fakeBasketState = "addressed"
		if (shippingAddress.firstName == "fail") {
			return this.fakeRequest({
				"code": "01",
				"message": "forced address fail",
				"errors": {
					"field": "error"
				}
			}, 400)
		} else if (shippingAddress.postcode >= 9000) {
			return this.fakeRequest({
				"code": 400,
				"message": "Validation failed",
				"errors": {
					"shippingAddress": [
						"shop_manager.shop_api.address.channel_delivers_zip"
					]
				}
			}, 400)
		}
		return this.fakeRequest({})
	}

	async "GET /shop-api/checkout/:token/payment"() {
		let result = await axios.get(config.MOCK_CHECKOUT_PAYMENT_URL, { params: { rand: Math.random() } })
		if (this.fakeCoupon && this.fakeCoupon.name == "huge") {
			//do not return payments if the basket value is 0
			result.data.payments[0].methods = {}
		}
		return result
	}

	"PUT /shop-api/checkout/:token/payment/:id"(url, urlmethod, { method }) {
		this.fakePayment = this.__fakePayment(method, method == 'boncard' ? 'BON' : '')
		return this.fakeRequest({})
	}

	"GET /shop-api/checkout/:token/shipping"() {
		return axios.get(config.MOCK_CHECKOUT_SHIPPING_URL, { params: { rand: Math.random() } })
	}

	"PUT /shop-api/checkout/:token/shipping/:id"() {
		this.fakeBasketState = "shipping_selected"
		return this.fakeRequest({})
	}

	"PUT /shop-api/checkout/:token/complete"(url, method, { email, deliverTime, confirmedAlcohol, tip, compensateCo2 }) {
		if (!confirmedAlcohol && config.MOCK_CART_HASALCOHOL) {
			return this.fakeRequest({
				"code": "400",
				"message": "Validation failed (force alkohol fail)",
				"errors": {
					"confirmedAlcohol": [
						"shopmanager.shopapi.alko"
					]
				}
			}, 400)
		} else if (deliverTime && deliverTime.indexOf(":45:") >= 0) {
			return this.fakeRequest({
				"code": "02",
				"message": "forced time fail",
				"errors": {
					"deliverTime": ["time not acceptable"]
				}
			}, 400)
		} else if (email.indexOf("token") >= 0) {
			return this.fakeRequest({
				"code": "02",
				"message": "validation",
				"errors": {
					"token": ["token not found"]
				}
			}, 400)
		} else if (deliverTime && deliverTime.indexOf("13:00") >= 0) {
			return this.fakeRequest({
				"code": "05",
				"message": "delivertime is not in the future enough",
				"errors": {
					"deliverTime": ["deliver time not valid anymore"]
				}
			}, 400)
		}
		if (tip > 0) {
			this.fakeTip = this.__fakeCartTip({ value: tip })
		}
		if (compensateCo2) {
			this.fakeCo2Compensate = true
		}
		this.fakeBasketState = "completed"
		return this.fakeRequest({})
	}

	async "GET /shop-api/orders/:token"(method, url, { path: { token } }) {
		const res = await axios.get(config.MOCK_ORDER_URL, { params: { rand: Math.random() } })
		if (this.fakePayment) {
			res.data.payments.length = 0
			res.data.payments.push(this.fakePayment)
		}
		if (this.fakeCoupon) {
			res.data.cartDiscounts[this.fakeCoupon.name] = this.fakeCoupon
			res.data.couponCode = this.fakeCoupon.name
		}
		res.data.items.length = 0
		res.data.items.push(...this.fakeCartItems)
		if (this.fakeTip) {
			res.data.items.push(this.fakeTip)
		}
		this.__fixCart(res.data)

		return res
	}

	async "GET /shop-api/zip/find/:brand/:method/:zip"(method, url, { path: { zip } }) {
		if (zip === 9999) {
			return this.fakeRequest(null, false)
		} else if (zip < 8000 || zip > 9000) {
			return this.fakeRequest({
				"code": 404,
				"message": "The \"zip\" has not been found"
			}, 404)
		} else if (zip > 8500 && zip < 9000) {
			return this.fakeRequest({
				contaoId: "butcher_2",
				deliveryPrice: 5,
				deliveryTime: 60,
				id: 2,
				minBasketFree: 80,
				minDeliveryAmount: 50,
				zip: "8000",
				zipLocations: [],
			})
		}

		const res = await axios.get(config.MOCK_ZIP_URL, { params: { rand: Math.random() } })
		if (zip == "8000") {
			res.data.zipLocations.length = 1
		}

		return res
	}
	async "GET /shop-api/channel/:brand"(method, url, { path: { brand } }) {
		let res = await axios.get(config.MOCK_CHANNELS_URL, { params: { rand: Math.random() } })

		let now = dayjs(config.LOCAL_TIME)
		res.data.forEach((location, i) => {
			this.__fakeLocationTimes(location.location, i)
		})

		return res
	}

	async "POST /shop-api/login"(method, url, { email, password }) {
		if (email.indexOf("fail") >= 0) {
			return this.fakeRequest({
				"code": 401,
				"message": "Invalid credentials."
			}, 401)
		} else if (email.indexOf("migrate") >= 0) {
			return this.fakeRequest({
				redirect: {
					key: 'MIGRATION_URL',
					params: {
						email,
					}
				}
			}, 403)
		} else {
			return this.fakeRequest({
				"token": "jwt-token.fake"
			}, 200)
		}
	}

	async "POST /shop-api/qr-token/qr2jwt"(method, url, { token }) {
		if (token.indexOf("fail") >= 0) {
			return this.fakeRequest({
				"code": 401,
				"message": "Invalid credentials."
			}, 401)
		} else {
			return this.fakeRequest({
				"token": "jwt-token.fake-qr"
			}, 200)
		}
	}

	async "POST /shop-api/register"(method, url, { email, password, firstName, lastName, checkTerms }) {
		if (!checkTerms) {
			return this.fakeRequest({
				"code": 400,
				"message": "Validation failed",
				"errors": {
					"checkTerms": [
						"Please accept the terms."
					]
				}
			}, 400)
		}
		else if (email.indexOf("used") >= 0) {
			return this.fakeRequest({
				"code": 400,
				"message": "Validation failed",
				"errors": {
					"email": [
						"This email is already used."
					]
				}
			}, 400)
		} else if (email.indexOf("fail") >= 0) {
			return this.fakeRequest({
				"code": 401,
				"message": "some error message"
			}, 401)
		} else if (email.indexOf("migrate") >= 0) {
			return this.fakeRequest({
				redirect: {
					key: 'MIGRATION_URL',
					params: {
						email,
					}
				}
			}, 403)
		} else {
			return this.fakeRequest({
			}, 204)
		}


	}

	async "GET /shop-api/me"(method, url, { headers: { Authorization } }) {
		if (!Authorization || Authorization.indexOf("fail") >= 0) {
			return this.fakeRequest({
				"code": 401,
				"message": "Expired JWT Token"
			}, 200)
		} else {
			return await this.__getUser();
		}
	}

	async "GET /shop-api/orders"(method, url, { headers: { Authorization } }) {
		const res = await axios.get(config.MOCK_ORDERS_URL, { params: { rand: Math.random() } })
		return res
	}

	async "GET /shop-api/me/products"(method, url, { headers: { Authorization } }) {
		const result = await axios.get(config.MOCK_ACCOUNT_PRODUCTS_URL, { params: { rand: Math.random() } })

		//filter slug fake
		result.data.items = result.data.items.slice(0, 3)

		//mock images
		result.data.items.forEach(p => {
			for (let image of p.images) {
				if (image.path.indexOf("http") != 0) {
					image.path = config.MOCK_PRODUCT_IMAGE
				}
			}
		})

		return result
	}

	async "PUT /shop-api/request-password-reset"(url, method, { email }) {
		if (email.indexOf("fail") >= 0) {
			return this.fakeRequest({
				"code": 500,
				"message": "Internal Server Error"
			}, 500)
		} else {
			return this.fakeRequest(null, 204)
		}
	}

	async "GET /shop-api/address-book/"(url, method, { headers: { Authorization } }) {
		if (!Authorization) {
			return this.fakeRequest({
				"code": 401,
				"message": "User not logged in"
			})
		} else if (!config.MOCK_ACCOUNT_HAS_ADDRESS) {
			// respond with empty list
			return this.fakeRequest([], 200)
		} else {
			return axios.get(config.MOCK_ACCOUNT_ADDRESSES_URL)
		}
	}

	async "GET /shop-api/customer/last-address?brand=:brand"(url, method, { headers: { Authorization } }) {
		if (!Authorization) {
			return this.fakeRequest({
				"code": 401,
				"message": "User not logged in"
			})
		} else if (!config.MOCK_ACCOUNT_HAS_ADDRESS) {
			// respond with empty list
			return this.fakeRequest([], 200)
		} else {
			const result = await axios.get(config.MOCK_ACCOUNT_ADDRESSES_URL);
			result.data = result.data.pop();
			return result;
		}
	}

	async "GET /shop-api/restore/:token"(url, method, { headers: { Authorization } }) {
		this.fakeCartItems = []
		return this.fakeRequest({
			"tokenValue": "fake-restore-124378147814585481"
		}, 200)
	}

	async "POST /shop-api/poinz/register"(method, url, { birthday, gender }, { group, headers: { Authorization } }) {
		const date = new Date(birthday);

		if (date.getFullYear() == 2017) {
			return this.fakeRequest({
				"code": 401,
				"message": "some error message"
			}, 401)
		} else {
			this.fakeAccountMergeWithMe = {
				poinzAvailable: true,
				poinz: 27,
			}
			return this.fakeRequest({
				success: true,
				errors: []
			}, 200)
		}
	}

	async "POST /shop-api/poinz/redeem"(method, url, { }, { headers: { Authorization } }) {
		if (Math.random() >= 0.5) {
			return this.fakeRequest({
				"code": 401,
				"message": "some error message"
			}, 401)
		} else {
			const date = new Date();
			const validDate = new Date();
			validDate.setDate(validDate.getDate() + 365);

			const poinz = this.fakeAccountMergeWithMe.poinz
			this.fakeAccountMergeWithMe.poinzAvailable = true
			this.fakeAccountMergeWithMe.poinz = poinz != null ? poinz - 10 : 7

			this.fakeAccountCoupon.push({
				"id": 14,
				"code": Date.now(),
				"name": "Poinz Gutschein",
				"discount": "20.-",
				"validUntil": validDate.toISOString(),
				"used": 0,
				"createdAt": date.toISOString(),
				"updatedAt": date.toISOString()
			})
			return this.fakeRequest({
			}, 204)
		}
	}

	async "POST /shop-api/customer/migrate-brands"(method, url, { email }) {
		const res = await axios.get(config.MOCK_MIGRATE_BRANDS_URL)
		if (email.indexOf("fail") >= 0) {
			return this.fakeRequest({
				"code": 500,
				"message": `User with ${email} email has not been found.`
			}, 500)
		}
		return res;
	}

	async "GET /shop-api/customer/active-brands" (method, url, { }) {
		const res = await axios.get(config.MOCK_MIGRATE_BRANDS_URL)
		return res;
	}

	async "POST /shop-api/customer/migrate"(method, url, { email, brand, checkTerms, migrateVerifyUrl }) {
		if (email.indexOf("fail") >= 0) {
			return this.fakeRequest({
				"code": 403,
				"message": "Etwas ist schief gelaufen."
			}, 403)
		} else if (!checkTerms) {
			return this.fakeRequest({
				"code": 400,
				"message": "Validation failed",
				"errors": {
					"checkTerms": [
						"Bitte akzeptiere die Datenschutzbestimmungen."
					]
				}
			}, 400)
		}
		return this.fakeRequest({
			redirect: {
				key: 'MIGRATION_VERIFY_URL',
				params: {
					email,
				}
			}
		}, 204);
	}

	async "POST /shop-api/customer/migrate-verify-email"(method, url, { email, token, brand }) {
		if (email.indexOf("fail") >= 0) {
			return this.fakeRequest({
				"code": 403,
				"message": "Etwas ist schief gelaufen."
			}, 403)
		}
		return this.fakeRequest({
			redirect: {
				key: 'MIGRATION_VERIFY_URL',
				params: {
					email,
				}
			}
		}, 204);
	}


	async "GET /shop-api/locations/with-reservation/:brand"({ method, url }) {
		const result = await axios.get(config.MOCK_LOCATIONRESERVATION_URL)

		let locations = result.data

		return this.fakeRequest(locations, 200)
	}

	async "POST /self-ordering-api/v1/create-order"(method, url, { items, shippingCode, coupons, expectedTotal }, { params: { channel } }) {
		if (coupons.length && coupons.includes('latefail')) {
			return this.fakeRequest({
				"code": "32",
				"message": "wrong coupon code",
			}, 400)
		} else if (coupons.length && coupons.includes('diff')) {
			return this.fakeRequest({
				"code": "33",
				"message": "expectedTotal was not the calculated total",
			}, 400)
		}
		const result = axios.get(config.MOCK_SELFORDERING_CREATEORDER)
		return result
	}

	async "GET /self-ordering-api/v1/init"(method, url, { params: { channel, deliverTime, orderNow } }) {
		const result = await axios.get(config.MOCK_SELFORDERING_INIT)

		//filter timelimited items
		const isLimitedTime = deliverTime ? deliverTime.indexOf(this.timelimitedTime) >= 0 : true
		result.data.products = result.data.products
			.filter(item => !(this.timelimitedProductCodes.includes(item.code) && !isLimitedTime))

		//mock images
		result.data.products.forEach(p => {
			for (let image of p.images) {
				if (image.path.indexOf("http") != 0) {
					image.path = config.MOCK_PRODUCT_IMAGE
				}
			}
		})
		result.data.taxons.self.children.forEach(p => {
			for (let image of p.images) {
				if (image.path.indexOf("http") != 0) {
					image.path = config.MOCK_PRODUCT_IMAGE
				}
			}
		})
		result.data.availableChildProducts.forEach(p => {
			for (let image of p.images) {
				if (image.path.indexOf("http") != 0) {
					image.path = config.MOCK_PRODUCT_IMAGE
				}
			}
		})

		let products = result.data.products
		// deref
		let derefProduct = (object, key) => {
			const p = object[key]
			if (typeof p === 'object' && p.code !== null) {
				if (!products.find(v => v.code === p.code)) {
					products.push(p)
				}
				object[key] = p.code
			}
		}
		result.data.availableChildProducts.forEach((p, i) => derefProduct(result.data.availableChildProducts, i))
		result.data.additionalProducts.forEach(rule => {
			rule.products.forEach((p, i) => derefProduct(rule.products, i))
		})

		result.data.products = products
		return result
	}

	async "POST /self-ordering-api/v1/validate-coupon"(method, url, { couponCode, deliverTime, deliverNow }, { params: { channel } }) {
		if (couponCode.includes('latefail')) {
			const result = await axios.get(config.MOCK_SELFORDERING_VALIDATECOUPON)
			result.data.code = 'latefail'
			return result
		} else if (couponCode.includes('fail')) {
			const result = await axios.get(config.MOCK_SELFORDERING_VALIDATECOUPON_FAIL)
			return this.fakeRequest(result.data, 400)
		} else if (couponCode.includes('perc')) {
			return await axios.get(config.MOCK_SELFORDERING_VALIDATECOUPON_PERC)
		}

		const result = await axios.get(config.MOCK_SELFORDERING_VALIDATECOUPON)
		return result

	}

	async "POST /self-ordering-api/v1/create-order"(method, url, { items, shippingCode, coupons, expectedTotal, deliverTime, orderNow }, { params: { channel } }) {
		if (coupons.length && coupons.includes('latefail')) {
			return this.fakeRequest({
				"code": "32",
				"message": "wrong coupon code",
			}, 400)
		} else if (coupons.length && coupons.includes('diff')) {
			return this.fakeRequest({
				"code": "33",
				"message": "expectedTotal was not the calculated total",
			}, 400)
		} else if (deliverTime && deliverTime.indexOf("13:00") >= 0) {
			return this.fakeRequest({
				"code": "05",
				"message": "delivertime is not in the future enough",
				"errors": {
					"deliverTime": ["deliver time not valid anymore"]
				}
			}, 400)
		}
		const result = await axios.get(config.MOCK_SELFORDERING_CREATEORDER)
		// fake guestredirect
		if (config.MOCK_BASKET_GUESTREDIRECT) {
			result.data.hasOnlyItemsOfRedirectTaxons = true
		}
		return result
	}

	async "GET /shop-api/qr-token/token" (method, url, { headers: { Authorization } }) {
		if (!Authorization || Authorization.indexOf("fail") >= 0) {
			return this.fakeRequest({
				"code": 401,
				"message": "Expired JWT Token"
			}, 200)
		} else {
			return this.fakeRequest({
				token: "abcdef1234567890"
			}, 200)
		}
	}

	async 'PUT /shop-api/me' (method, url, { firstName, lastName, phoneNumber, gender }, { headers: { Authorization } }) {
		if (!Authorization || Authorization.indexOf("fail") >= 0) {
			return this.fakeRequest({
				"code": 401,
				"message": "Expired JWT Token"
			}, 200)
		} else if (!firstName || !lastName || !phoneNumber || !gender) {
			return this.fakeRequest({
				"code": 401,
				"message": "Not enough data supplied"
			}, 200)
		} else {
			this.fakeAccountMergeWithMe = {
				...this.fakeAccountMergeWithMe,
				firstName,
				lastName,
				phoneNumber,
				gender
			}
			return await this.__getUser();
		}
	}

	async __getUser() {
		let user = await axios.get(config.MOCK_ACCOUNT_ME_URL);

		if (this.fakeAccountMergeWithMe) {
			user.data = {
				...user.data,
				...this.fakeAccountMergeWithMe
			}
		}

		this.fakeAccountCoupon.forEach(coupon => {
			if (!user.data.promotionCoupons.includes(coupon)) {
				user.data.promotionCoupons.push(coupon);
			}
		})

		return user;
	}

	async __getTaxonProducts () {
		if (this.productsCache instanceof Promise) {
			return this.productsCache
		} else if (this.productsCache != null) {
			return this.productsCache
		}
		let resolveCache
		this.productsCache = new Promise((resolve, reject) => resolveCache = resolve)
		const response = await axios.get(config.MOCK_PRODUCTS_URL, { params: { rand: Math.random() } })
		this.productsCache = response
		resolveCache(this.productsCache)
		return this.productsCache
	}

	__fixCart(cart) {
		cart.items.forEach(v => {
			//v.children = this.fakeChildProducts[v.id] || []
			let product = this.fakeProducts.find(p => p.code == v.product) || v.product
			v.total = v.quantity * product.variants[0].price.current
			v.total = v.children.reduce((p, c) => {
				return p + v.total
			}, v.total)
		})
		let total = cart.items
			.reduce((p, c) => p + c.total, 0)
		if (total < cart.zip.minBasketFree * 100 && cart.shipments[0].method.code == "delivery") {
			cart.totals.shipping = cart.zip.deliveryPrice * 100
			total += cart.totals.shipping
		}
		if (this.fakeCo2Compensate) {
			cart.totals.co2Compensation = cart.channel.location.co2CompensationAmount
			cart.compensateCo2 = true
			total += cart.totals.co2Compensation
		}
		Object.values(cart.cartDiscounts)
			.forEach(discount => total += discount.amount.current)

		cart.totals.total = Math.max(total, 0)

		// calculate tip
		if (this.fakeTip) {
			cart.totals.totalWithoutTip = cart.totals.total - this.fakeTip.total
		} else {
			cart.totals.totalWithoutTip = cart.totals.total
		}
		cart.totals.promotion = Object.values(cart.cartDiscounts)
			.reduce((c, d) => c += d.amount.current, 0)
		cart.totals.items = cart.items.reduce((p, c) => p + c.total, 0) - Math.abs(cart.totals.promotion)


		if (this.fakeDeliverTime) {
			cart.deliverTime = this.fakeDeliverTime
			cart.orderNow = this.fakeOrderNow
		} else {
			// fake cart in future
			let now = dayjs(config.LOCAL_TIME)
			// next round 45 minutes in
			let deliveryTime = now.add(Math.ceil(now.get('minute') / 15) * 15 - now.get('minute') + 45, 'minutes')
			cart.deliverTime = dayjs(deliveryTime).format() // time currently the default format
		}
	}

	__fakeLocationTimes(location, index = 0) {
		let now = dayjs(config.LOCAL_TIME).tz(timeZone)
		//now = now.add(1, 'day')
			;[location.takeaway, location.delivery] // yes, first semicolon fix ever
				.forEach((v) => {
					if (!v) {
						// we skip if its empty
						return
					}
					let openingHours = []
					let date = now.startOf('date').hour(10).tz(timeZone)
					for (let i = 0; i < 14; i++) {
						date = dayjs.tz(date.format('YYYY-MM-DD HH:mm'), timeZone)

						// let checkDateStr = dayjs.tz(`${date.format('YYYY-MM-DD')} 10:00`, timeZone).format()
						// if (checkDateStr != date.hour(10).format()) {
						// 	console.error('DateStrCheck Failed', date.hour(10).format(), checkDateStr)
						// }

						let dayofweek = date.day()
						if (dayofweek == 0 && false) { // sunday closed

						} else {
							openingHours.push({
								timelineStart: date.hour(10).format(),
								timelineEnd: date.hour(13).format(),
							})
							openingHours.push({
								timelineStart: date.hour(index == 1 ? 19 : 17).format(),
								timelineEnd: date.hour(22).format(),
							})
						}
						date = date.add(1, 'day')
					}
					v.openingHours = openingHours
				})
	}

	__fakeProductStock(product, stock) {
		// we feed the all variants otherwise only 1 product (both stock)
		let variants = Object.values(product.variants)
		if (variants.length < 2) {
			variants = [ product ]
		}
		variants.forEach((v, i) => {
			if (stock == "gradient") {
				// gradient stock
				v.stock = i < 2 ? 1 - i : -1
			} else if (stock == "none") {
				v.stock = 0
			}
		})
	}

	__fakePayment(id, datatrans = '') {
		return {
			"state": "cart",
			"method": {
				"code": id,
				"name": id,
				"description": "Quasi est quae laudantium eius sed sit adipisci.",
				"instructions": "",
				"datatransPaymentMethod": datatrans,
			},
			"price": {
				"current": 680,
				"currency": "CHF"
			}
		}
	}

	__fakeCoupon(code) {
		let value = -680
		if (code == "huge") {
			value = -50000
		}
		return {
			"name": code,
			"amount": {
				"current": value,
				"currency": "CHF"
			}
		}
	}

	__fakeCartTip({ value }) {
		const cartItem = this.__fakeCartItem({ code: "99999999", price: value, name: "Tip", variantName: "Tip" })
		cartItem.product.isTip = true
		return cartItem
	}

	__fakeCartItem({ quantity = 1, editable = false, configurable = false, price = 100, code = "10155010", name = "Original Caesar Salad", variantName = "Original Caesar Salad", childCodes = [] } = {}) {
		return {
			"id": this.fakeCartItemId++,
			"quantity": quantity,
			"total": quantity * 100,
			"product": {
				"code": code,
				"name": name,
				"slug": "butcher_original-caesar-salad",
				"channelCode": "butcher_zurich_niederdorf_1",
				"description": "<p>Lattich mit Pouletbruststreifen und Parmesan an Butcher's Caesardressing</p>",
				"shortDescription": "",
				"averageRating": 0,
				"taxons": {
					"others": [
						"butcher",
						"butcher-Sides",
						"butcher-salads",
						"butcher-alle",
						"negishi-sushi",
						"negishi-plates",
						"negishi-specials",
						"nooch-curries",
						"nooch-starters"
					]
				},
				"availableChildProducts": [
					"990000",
					"990001",
					"990002",
					"990003",
					"990004",
					"990005",
					"990006",
					"990007",
					"990008",
				],
				"defaultChildProducts": [
					"990000",
					"990006",
				],
				"variants": [
					{
						"code": code,
						"name": variantName,
						"axis": [],
						"nameAxis": {},
						"price": {
							"current": 100,
							"currency": "CHF"
						},
						"images": []
					}
				],
				"attributes": [],
				"associations": [],
				"images": [
					{
						"path": "e3/9b/821dbbc46196f4100167b972da15.jpeg"
					}
				],
				"_links": {
					"self": {
						"href": "/shop-api/products/by-slug/butcher_original-caesar-salad"
					}
				},
				"isEditable": editable,
				"isConfigurable": configurable,
			}
		}
	}

	__fakeCartAdditionalItem({ quantity = 1, free = false, code = "10563002" } = {}) {
		return {
			"id": this.fakeCartItemId++,
			"quantity": quantity,
			"total": free ? 0 : 100 * quantity,
			"product": {
				"isAdditional": true,
				"code": code,
				"name": "Portion Wasabi",
				"slug": "negishi_portion-wasabi",
				"channelCode": "negishi_basel_barfi_2",
				"description": "<p>abc</p>",
				"shortDescription": "",
				"averageRating": 0,
				"taxons": {
					"others": []
				},
				"variants": [
					{
						"code": "10563002",
						"name": "Portion Wasabi",
						"axis": [],
						"nameAxis": {},
						"price": {
							"current": free ? 0 : 100,
							"currency": "CHF"
						},
						"originalPrice": {
							"current": free ? 0 : 100,
							"currency": "CHF"
						},
						"images": []
					}
				],
				"attributes": [
					{
						"code": "icon",
						"type": "select",
						"value": [
							"Spice"
						]
					}
				],
				"associations": [],
				"images": [],
				"_links": {
					"self": {
						"href": "/shop-api/products/by-slug/negishi_portion-wasabi"
					}
				}
			}
		}
	}

	__setItemChildren(item, childCodes, products) {
		if (childCodes) {
			item.children = childCodes.map(childCode => {
				const product = products.find(p => p.code == childCode)
				const variant = product.variants[0]
				return {
					id: 0,
					quantity: 1,
					total: variant.price.current,
					product,
					variantCode: variant.code
				}
			})
		}
	}
}
